module.exports = __webpack_public_path__ + "img/academy_bubble_scale.022c35d8.png";